export default __webpack_public_path__ + "static/media/plus-black-symbol.fdc55561.svg";